import React from 'react';

export default function Blogs() {
    return (
        <div>
           
           <div className="container box-border flex flex-wrap items-center justify-center gap-4 mt-4">
           <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/RhOisqrYpCw"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
            <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/O0k1HPcZnrg"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
            <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/XtsUcqa0CUY"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
            <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/exxj2oliHTo"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
           </div>
             
             
        </div>
    )
}
